import * as A from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as t } from "../../utilities/transformations.js";
import { distort as I } from "../../helpers/distort.js";
import { grain as O } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as D } from "../../utilities/uv.js";
const q = {
  name: "Synthesis3",
  collection: "synthesis",
  tags: ["wave", "gradient"],
  props: {
    colorA: {
      type: String,
      default: "#7416cc",
      transform: t,
      description: "The left color of the first wave"
    },
    colorB: {
      type: String,
      default: "#ff025b",
      transform: t,
      description: "The right color of the first wave"
    },
    colorC: {
      type: String,
      default: "#ffb833",
      transform: t,
      description: "The left color of the second wave"
    },
    colorD: {
      type: String,
      default: "#ff0008",
      transform: t,
      description: "The right color of the second wave"
    },
    backgroundColor: {
      type: String,
      default: "#0a1029",
      transform: t,
      description: "The background color"
    },
    frequency: {
      type: Number,
      default: 1,
      description: "The frequency of the waves"
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    },
    amplitude: {
      type: Number,
      default: 0.07,
      description: "The amplitude of the waves"
    },
    smoothness: {
      type: Number,
      default: 0.25,
      description: "How soft the edges of the waves are"
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: p,
      uv: h,
      time: n,
      sin: s,
      mix: r,
      abs: c,
      smoothstep: a,
      add: d
    } = A, i = 0.03, l = 0.03, m = 1.2, _ = 4, g = 0, e = I(h(), 0.08, 1, 10), y = s(
      e.x.mul(o.frequency.uniform).mul(Math.PI * 2).add(n.mul(o.speed.uniform))
    ).mul(o.amplitude.uniform).add(0.5).sub(i), T = s(
      e.x.mul(o.frequency.uniform).mul(Math.PI * 2).add(n.mul(o.speed.uniform).add(_))
    ).mul(o.amplitude.uniform).add(0.5).sub(i).add(g), b = r(
      o.colorA.uniform,
      o.colorB.uniform,
      e.x
    ), E = r(
      o.colorC.uniform,
      o.colorD.uniform,
      e.x
    ), v = c(e.y.sub(y)).add(e.y.mul(l)), S = c(e.y.sub(T)).add(e.y.mul(l)), f = a(
      o.smoothness.uniform,
      0,
      v
    ), u = a(
      o.smoothness.uniform,
      0,
      S
    ), { correctedUV: w } = D(), C = O(0.8)(w), N = d(
      b.mul(f),
      E.mul(u)
    ).mul(m).sub(C.mul(m));
    return p(
      r(
        o.backgroundColor.uniform,
        N,
        d(f, u).min(1)
      ),
      1
    );
  }
};
export {
  q as componentDefinition,
  q as default
};
